import React, { useState } from "react";
import {
  Paper,
  Typography,
  Grid,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Icon,
  TableFooter,
  TablePagination,
  Select,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import { LOCALE } from "../../../properties/Locale";
import { useDispatch } from "react-redux";
import { changePageTitle } from "../../../common/actions/CommonActions";
import { VacancyRepository } from "../../vacancy/VacancyRepository";
import { VacancyAppRepository } from "../../vacancyApplication/VacancyAppRepository";
import Card from "../../../common/components/Card/Card";
import CardHeader from "../../../common/components/Card/CardHeader";
import CardBody from "../../../common/components/Card/CardBody";
import { useStyles } from "@material-ui/pickers/views/Calendar/SlideTransition";
import moment from "moment";
import { Redirect } from "react-router-dom";

export default function CommisionPreviewComponent() {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [vacancyApps, setVacancyApps] = React.useState();
  const [totalAppsRemaining, setTotalAppsRemaining] = React.useState(0);
  const [redirect, setRedirect] = React.useState();
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [step, steStep] = useState(0);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [vacancies, setVacancies] = useState();
  const [selectedVacancy, setSelectedVacancy] = useState("");

  React.useEffect(() => {
    dispatch(changePageTitle(`${LOCALE.view_graded_applications}`));
  }, [dispatch]);

  React.useEffect(() => {
    VacancyAppRepository.getAllForPreview({
      vacancyId: selectedVacancy,
      firstName: firstName,
      lastName: lastName,
    }).then((res) => {
      setTotalAppsRemaining(res.data.totalElements);
      setVacancyApps(res.data);
      console.log(res.data);
    });
  }, [selectedVacancy, firstName, lastName]);

  const openVacancy = (vacId, appId) => {
    setRedirect("/app/vacancy-preview/" + vacId + "/" + appId);
  };

  React.useEffect(() => {
    VacancyRepository.fetchAllVacancy({
      page: 0,
      size: 100,
      orderBy: "dateCreated",
      orderDirection: "DESC",
    }).then((res) => {
      setVacancies(res.data.content);
    });
  }, []);

  return (
    <div>
      {redirect && <Redirect to={redirect} />}
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <FormControl
            className={classes.formControl}
            variant="outlined"
            size="small"
            fullWidth
          >
            <InputLabel id="demo-simple-select-label1">
              {LOCALE.choose_vacancy}
            </InputLabel>
            <Select
              labelId="demo-simple-select-label1"
              id="demo-simple-select1"
              label={LOCALE.choose_vacancy}
              value={selectedVacancy}
              onChange={(e) => setSelectedVacancy(e.target.value)}
            >
              <MenuItem key={221312} value={""}>
                {LOCALE.all}
              </MenuItem>
              {vacancies?.map((item, index) => (
                <MenuItem key={index} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item md={4}>
          <TextField
            id="firstName"
            label={LOCALE.firstName}
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            variant="outlined"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item md={4}>
          <TextField
            id="lastName"
            label={LOCALE.lastName}
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            variant="outlined"
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>
      <br></br> <br></br>
      <Card>
        <CardHeader color="theme">
          <Typography>{LOCALE.view_graded_applications}</Typography>
          <Typography style={{ float: "right" }}>
            {LOCALE.total_left}: {totalAppsRemaining}
          </Typography>
        </CardHeader>
        <CardBody>
          <Table aria-label="users table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell></TableCell>
                <TableCell
                  style={{ fontWeight: "bold" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.school}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.teaching_languages}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.created_at}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.submissionDate}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.status}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                  style={{
                    width: "100px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {LOCALE.actions}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vacancyApps && vacancyApps.length === 0 && (
                <TableRow>
                  <TableCell colSpan={10}>
                    <Icon style={{ verticalAlign: "bottom", color: "orange" }}>
                      warning
                    </Icon>
                    {LOCALE.no_apps_for_evaluating}
                  </TableCell>
                </TableRow>
              )}
              {vacancyApps?.map((vacancyApp, index) => (
                <TableRow
                  style={index % 2 === 1 ? { background: "#f0f0f0" } : {}}
                >
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{vacancyApp.basicInfo.school.name}</TableCell>
                  <TableCell>
                    {LOCALE.getString(vacancyApp.basicInfo.teachingLanguage)}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {vacancyApp.dateCreated &&
                      moment(vacancyApp.dateCreated).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {vacancyApp.submissionDate &&
                      moment(vacancyApp.submissionDate).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {vacancyApp.status && vacancyApp.status === "DRAFT" && (
                      <Chip
                        label={LOCALE.getString("DRAFT")}
                        style={{
                          color: "white",
                          backgroundColor: "orange",
                        }}
                      />
                    )}
                    {vacancyApp.status &&
                      vacancyApp.status === "COMMISION_EVAL" && (
                        <Chip
                          label={LOCALE.getString("COMMISION_EVAL")}
                          style={{
                            color: "white",
                            backgroundColor: "green",
                          }}
                        />
                      )}
                  </TableCell>
                  <TableCell>
                    <Button
                      color="primary"
                      variant="contained"
                      size="small"
                      onClick={() =>
                        openVacancy(vacancyApp.vacancy.id, vacancyApp.id)
                      }
                    >
                      <Icon size={10}>edit</Icon> &nbsp;
                      {LOCALE.open}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardBody>
      </Card>
    </div>
  );
}
